// Estado compartilhado do tour de boas-vindas.
//
// Fica fora de `WelcomeTour.tsx` pela mesma razao que `useAuth` fica fora de
// `AuthProvider`: um arquivo que exporta componente e nao-componente ao mesmo
// tempo quebra o Fast Refresh do Vite.

export const TOUR_STORAGE_KEY = 'centralcheck_welcome_tour_done';

/** Aviso de que alguem pediu o tour de novo pela Central de Ajuda. */
export const EVENTO_REINICIO_DO_TOUR = 'centralcheck:reiniciar-tour';

/**
 * Recomeca o tour do primeiro passo.
 *
 * A Central de Ajuda apagava a chave do `localStorage` e navegava para o
 * dashboard, contando com uma remontagem que nao acontece: `WelcomeTour` vive
 * na rota de layout do bloco protegido e permanece montado enquanto as telas
 * trocam. O unico efeito que le a chave roda ao montar, entao "Refazer tour"
 * nao reabria nada.
 */
export function reiniciarTour() {
  localStorage.removeItem(TOUR_STORAGE_KEY);
  window.dispatchEvent(new Event(EVENTO_REINICIO_DO_TOUR));
}
